import { cookies } from './cookies';

import { user } from './user';

class Util {
  setCookies(name, value, iHours, domain = '.haiziwang.com') {
    const oDate = new Date();
    oDate.setHours(oDate.getHours() + iHours);
    document.cookie = name + '=' + value + ';expires=' + oDate + ';domain=' + domain + ';path=/';
  }
    /**
     * 确认登录
     */
    ensureLogin(){
        if(!user.id) {
            
            return false;
        } else {
            return true
        }
    }
    /**
     * 是否已登录
     */
    isLogin(){
        const id = user.id
        if(id){
            return true
        } else {
            return false
        }
    }
    /**
     * 获取元素的offsetTop
     * @param {*} 元素 
     * @param {*} 容器 
     */
    getOffsetTop(element, container = window) {
        if (!element) {
          return 0;
        }
      
        if (!element.getClientRects().length) {
          return 0;
        }
      
        const rect = element.getBoundingClientRect();
      
        if (rect.width || rect.height) {
          if (container === window) {
            container = element.ownerDocument.documentElement;
            return rect.top - container.clientTop;
          }
          return rect.top - container.getBoundingClientRect().top;
        }
      
        return rect.top;
      }
    /**
     * 清楚所有cookie
     */
    clearCookies(){
      Object.keys(cookies.get()).forEach(function(cookieName) {
        cookies.remove(cookieName);
      });
    }
    /**
     * 动态添加js
     * @param {*} url 
     * @param {*} callback 
     */
    loadJs(url,callback){
      var script=document.createElement('script');
        script.type="text/javascript";
        if(typeof(callback)!="undefined"){
          if(script.readyState){
            script.onreadystatechange=function(){
              if(script.readyState == "loaded" || script.readyState == "complete"){
                script.onreadystatechange=null;
                callback();
              }
            }
          }else{
            script.onload=function(){
              callback();
            }
          }
        }
        script.src=url;
        document.body.appendChild(script);
    }
}

export const util = new Util()